import type { Language } from '../types';

export type PublicPlatformSettings = {
  platformName: string;
  contactPerson: string;
  mobilePhone: string;
  whatsappNumber: string;
  supportEmail: string;
  salesEmail: string;
  addressText: string;
  businessHoursText: string;
  aboutShortEn: string;
  aboutShortAr: string;
  aboutShortCkb: string;
  aboutFullEn: string;
  aboutFullAr: string;
  aboutFullCkb: string;
  facebookUrl: string;
  instagramUrl: string;
  linkedinUrl: string;
  youtubeUrl: string;
  footerContactText: string;
  footerCopyrightText: string;
  updatedAt?: string;
};

export function phoneDigits(raw: string): string {
  return (raw || '').replace(/[^\d]/g, '');
}

export function telHref(phone: string): string | null {
  const digits = phoneDigits(phone);
  if (!digits) return null;
  return `tel:+${digits}`;
}

/** Prefill WhatsApp inquiry; product-aware when productName is provided. */
export function whatsappPrefill(
  language: Language,
  platformName: string,
  productName?: string
): string {
  const brand = platformName || 'BeCoder';
  if (productName) {
    if (language === 'ar') return `مرحبًا ${brand}، أود الاستفسار عن ${productName}.`;
    if (language === 'ckb') return `سڵاو ${brand}، دەمەوێت پرسیار بکەم دەربارەی ${productName}.`;
    return `Hello ${brand}, I would like to ask about ${productName}.`;
  }
  if (language === 'ar') return `مرحبًا ${brand}، أود التواصل معكم.`;
  if (language === 'ckb') return `سڵاو ${brand}، دەمەوێت پەیوەندیتان پێوە بکەم.`;
  return `Hello ${brand}, I would like to get in touch.`;
}

export function whatsappHref(
  whatsappNumber: string,
  language: Language,
  platformName: string,
  productName?: string
): string | null {
  const digits = phoneDigits(whatsappNumber);
  if (!digits) return null;
  const text = encodeURIComponent(whatsappPrefill(language, platformName, productName));
  return `https://wa.me/${digits}?text=${text}`;
}

export function aboutShort(settings: PublicPlatformSettings, language: Language): string {
  if (language === 'ar') return settings.aboutShortAr || settings.aboutShortEn;
  if (language === 'ckb') return settings.aboutShortCkb || settings.aboutShortEn;
  return settings.aboutShortEn;
}

export function aboutFull(settings: PublicPlatformSettings, language: Language): string {
  if (language === 'ar') return settings.aboutFullAr || settings.aboutFullEn;
  if (language === 'ckb') return settings.aboutFullCkb || settings.aboutFullEn;
  return settings.aboutFullEn;
}

export function configured(value?: string | null): boolean {
  return Boolean((value || '').trim());
}
